import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { User, UserService } from '@app/core';

interface IUserPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}
@Pipe({
    name: 'user', pure: false,
    standalone: false
})
export class UserPipe
  extends AlloxCommonAsyncPipe<User>
  implements IAlloxAsyncPipeFetch<User>, PipeTransform {

  constructor(private service: UserService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  fetchDependency(value: string) {
    return this.service.fetch(value);
  }

  makeText(value: string, obj: User, option?: IUserPipeOption) {
    if (!obj) {
      return '';
    }
    return obj.displayName;
  }

}
